import { z } from "zod";

export const announcementSchema = z.object({
    _id: z.string().optional(),

    group_id_arr: z
        .array(z.string())
        .min(1, { message: "At least one group must be selected" }),

    url: z
        .union([
            z.string().url({ message: "URL must be a valid format (e.g., https://...)" }),
            z.null()
        ])
        .optional(),

    message: z.string().nullable().optional(),

    img_url: z.string().nullable().optional(),
});
